//initialize
var analyticsInitialized = false;
try {
  GameAnalytics("initialize", "bbaf9db13f1889a43438b2e4515ade01", "17d6c2865ac27cd6cfbeee2cf577f06258c3175e");
  analyticsInitialized = true;
} catch (e) {
  analyticsInitialized = false;
}
//level started
function analyticsLevelStarted(levelNum) {
  if (!analyticsInitialized) return;

  GameAnalytics("addProgressionEvent", "Start", "level " + levelNum);
}

//level failed
function analyticsLevelFailed(levelNum) {
  if (!analyticsInitialized) return;

  GameAnalytics("addProgressionEvent", "Fail", "level " + levelNum);
}

//level completed
function analyticsLevelCompleted(levelNum) {
  if (!analyticsInitialized) return;

  GameAnalytics("addProgressionEvent", "Complete", "level " + levelNum);
}

//error event - severity (Debug, Info, Warning, Error, Critical)
function analyticsErrorEvent(errorMsg, severity) {
  if (!analyticsInitialized) return;

  severity = severity || "Debug";
  GameAnalytics("addErrorEvent", severity, errorMsg);
}

function analyticsCustiomEvent(eventName, value) {
  if (!analyticsInitialized) return;

  if (value != undefined) {
    GameAnalytics("addDesignEvent", eventName, value);
  } else {
    GameAnalytics("addDesignEvent", eventName);
  }
}
